import { render, staticRenderFns } from "./PostingModule.vue?vue&type=template&id=22756e57&scoped=true"
import script from "./PostingModule.vue?vue&type=script&lang=js"
export * from "./PostingModule.vue?vue&type=script&lang=js"
import style0 from "./PostingModule.vue?vue&type=style&index=0&id=22756e57&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22756e57",
  null
  
)

export default component.exports